// extracted by mini-css-extract-plugin
export default {"products":"rs-z","card":"ss-z","oosMessaging":"ts-z"};